import DatePick from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'

export default {
  components: {DatePick},
  data () {
    return {
      dateFormat: 'yyyy-MM-dd',
      ja: ja,
      pickedDate: '',
      pickedDate2: '',
      pickedDateCopy: '',
      years: [],
      months: [],
      days: [],
      dateYear: 0,
      dateMonth: 1,
      dateDay: 1
    }
  },

  created () {
    // console.log('Created ', this.componentName)
    // if (this.mode === 'create') {
    //   this.pickedDate = this.getCurrentDate()
    //   this.pickedDateCopy = this.pickedDate
    //   this.pickedDate2 = this.pickedDate
    // } else { // edit
    //   this.pickedDate = this.
    // }
  },

  mounted () {
  },

  computed: {
    isDateOk: function () {
      const date = this.dateYear.toString() + '-' + this.dateMonth.toString() + '-' + this.dateDay.toString()
      const ms = new Date(this.dateYear.toString() + '-' + this.dateMonth.toString() + '-' + this.dateDay.toString()).getTime()
      const ts = Math.floor(ms / 1000)
      this.pickedDate = date
      if (this.lic.expiredAt < ts) {
        return false
      }
      return true
    }
  },

  filters: {
  },

  watch: {
  },

  methods: {
    setSelectedDate (picked) {
      const date = new Date(picked)
      this.dateYear = date.getFullYear()
      this.dateMonth = date.getMonth() + 1
      this.dateDay = date.getDate()
    },

    selectedDate (returnedDate) {
      // datepickerのselectイベントの返り値が引数になる。
      // Wed Jun 05 2019 09:00:00 GMT+0900 (日本標準時)
      var date = returnedDate.toString()
      var year = date.slice(11, 15)
      var day = date.slice(8, 10)
      var month = '01'
      var monthTemp = date.slice(4, 7)
      var months = [
        {name: 'Jan', val: '01'},
        {name: 'Feb', val: '02'},
        {name: 'Mar', val: '03'},
        {name: 'Apr', val: '04'},
        {name: 'May', val: '05'},
        {name: 'Jun', val: '06'},
        {name: 'Jul', val: '07'},
        {name: 'Aug', val: '08'},
        {name: 'Sep', val: '09'},
        {name: 'Oct', val: '10'},
        {name: 'Nov', val: '11'},
        {name: 'Dec', val: '12'}
      ]

      for (let i = 0; i < months.length; i++) {
        if (months[i].name === monthTemp) {
          month = months[i].val
          break
        }
      }
      this.pickedDate = year + '-' + month + '-' + day
    },

    selectedDate2 (returnedDate) {
      // datepickerのselectイベントの返り値が引数になる。
      // Wed Jun 05 2019 09:00:00 GMT+0900 (日本標準時)
      var date = returnedDate.toString()
      var year = date.slice(11, 15)
      var day = date.slice(8, 10)
      var month = '01'
      var monthTemp = date.slice(4, 7)
      var months = [
        {name: 'Jan', val: '01'},
        {name: 'Feb', val: '02'},
        {name: 'Mar', val: '03'},
        {name: 'Apr', val: '04'},
        {name: 'May', val: '05'},
        {name: 'Jun', val: '06'},
        {name: 'Jul', val: '07'},
        {name: 'Aug', val: '08'},
        {name: 'Sep', val: '09'},
        {name: 'Oct', val: '10'},
        {name: 'Nov', val: '11'},
        {name: 'Dec', val: '12'}
      ]

      for (let i = 0; i < months.length; i++) {
        if (months[i].name === monthTemp) {
          month = months[i].val
          break
        }
      }
      this.pickedDate2 = year + '-' + month + '-' + day
    },

    getCurrentDate: function () {
      var format = 'YYYY-MM-DD'
      var date = new Date()
      // フォーマット文字列内のキーワードを日付に置換する
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      // format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
      // format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
      // format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));

      return format
    },

    checkPastDate: function (picked) {
      let targetDate = new Date(picked).getTime() / 1000
      let currentDate = new Date(this.getCurrentDate()).getTime() / 1000

      // console.log('targetDate ', targetDate)
      // console.log('currentDate ', currentDate)
      // console.log('(targetDate - currentDate) ', (targetDate - currentDate))
      if ((targetDate - currentDate) >= 0) {
        return true
      } else {
        return false
      }
    },

    checkTerm (d1, d2, maxDays) {
      var start = new Date(d1)
      var end = new Date(d2)

      // 差日を求める（86,400,000ミリ秒＝１日）
      var termDay = (end - start) / 86400000

      // 集計期間の範囲に、連絡の開始日が含まれているか？
      if (termDay < 0) {
        return '終了日が開始日よりも<br>早い日付になっています！'
      } else if (termDay === 0) {
        return '終了日と開始日が同じです！'
      } else if (termDay > maxDays) {
        return '期間が' + maxDays + '日を超えています！'
      } else {
        return 'OK'
      }
    },

    checkSelectableTerm (picked) {
      const date = new Date(picked).getTime() // yyyy-mm-dd
      const target = Math.floor(date / 1000)
      const selectableTerm = this.lic.expiredAt

      // 選択日が無料, ベーシックの選択可能期間を超えていないかチェック
      if (target > selectableTerm) {
        if (this.lic.role !== 'premium') {
          return false
        }
      }
      return true
    },

    convDateToTimeStamp (item) {
      const year = item.slice(0, 4) // YYYY
      const month = item.slice(5, 7) // MM
      const day = item.slice(8, 10) // DD
      const timestamp = new Date(year + '/' + month + '/' + day).getTime()

      return Math.floor(timestamp / 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_date.js